/**
 * Экстры дня ОО-дашборда (23.08, Саша): GET /api/game-reports/day-extras —
 * доп-материалы игр (подписанные превью/стрим клиентского прокси) и
 * Unifans-игроки (подписанные аватарки). Возвращает готовые map'ы
 * booking_id → строки; сеть/ошибки → пустые map'ы (карточки без экстр).
 */
import { api } from "../api/client";

/** Доп-материал игры: подписанные превью/стрим клиентского прокси. */
export interface OoMaterial { id: number; kind: string; duration: string; poster: string | null; stream: string | null }
/** Unifans-игрок игры: имя + подписанная аватарка (/api/client/avatar). */
/** 07.09 (владелец): via — как человек связан с игрой (рамка чипа): owner — капитан/заказчик брони (золотая),
 *  qr — добавился сам по QR оператора во время игры (голубая), invited — добавил капитан или кто-то другой
 *  (зелёная), link — персональная ссылка оператора (розовая). by — кто привёл (имя), если известно. */
export type OoFanVia = "owner" | "qr" | "invited" | "link";
export interface OoFan { telegramId: number; name: string; username: string | null; verified: boolean; avatar: string; via: OoFanVia; by: string | null }

/** Бронь, созданная в этот день (на любую дату игры) — блок «Пришли сегодня». */
export interface OoCreated {
  id: number; quest: string; date: string; time: string; type: string; status: string;
  source: string | null; channel: string | null; telegram: string | null; players: number; sum: number;
  tea: boolean;
  /** есть предоплата (27.08, владелец: квест зелёным/оранжевым в «Пришли сегодня») */
  prepaid: boolean;
}
/** Действие ДК за день (26.08, владелец): отмена/перенос/восстановление из audit_log. */
export interface OoDcAction {
  action: string; label: string; reason: string; staff: string; at: string;
  /** 03.09 (владелец): тап по действию — краткая история брони */
  bookingId: number | null; bookingDate: string | null;
  /** 03.09: время и статус брони — день сетки для модалки и гейт «Открыть бронь» */
  bookingTime: string | null; bookingStatus: string | null;
  info: { createdBy: string; createdAt: string; dcName: string | null; editors: string[] } | null;
}
/** Допработа дня — для мини-блока «на смене». */
export interface OoExtraWorkRow { operator: string; timeFrom: string; timeTo: string; description: string }
/** Админ зала дня — фуксией в «Сегодня работают» (26.08, владелец). */
export interface OoHallAdminRow { operator: string; operatorId: string; branch: string; timeFrom: string; timeTo: string }
/** Карточка игрока из отчёта оператора (имя/др/теги/капитан) — 27.08. */
export interface OoReportPlayer { name: string; birthDate: string; phone: string; captain: boolean; tags: string[] }
/** Строка таблички «данные с вейверов» — 27.08. */
export interface OoWaiverPerson { fio: string; birthDate: string; phone: string }
/** Фото вейвера игры (27.08): id для /api/game-reports/waiver-file/:id. */
export interface OoWaiverPhoto { id: number; name: string; by: string }
/** Текст отзыва оператора об операторе (peer-review) — 27.08. */
export interface OoPeerText { author: string; subject: string | null; activity: string; impression: string }
/** МК/допуслуга игры: кто вёл и ставка (28.08, владелец — чипы в карточке). */
export interface OoMcOp { id: number; mcName: string; opName: string; rate: number }
/** 19.09: услуга есть в брони, но оператор на неё не назначен — ОО назначает из карточки. */
export interface OoMcNeed { mcId: string; mcName: string }
/** 26.09: прайс КАЖДОЙ услуги брони — для «Ожидалось», когда МК добавили после сдачи отчёта. */
export interface OoMcPrice { mcId: string; mcName: string; base_price: number | null; threshold: number | null; extra_per_player: number | null }

export interface ExtrasMaps {
  mats: Map<string, OoMaterial[]>; fans: Map<string, OoFan[]>; created: OoCreated[]; extrawork: OoExtraWorkRow[]; halladmins: OoHallAdminRow[]; dcactions: OoDcAction[];
  rplayers: Map<string, OoReportPlayer[]>; wpersons: Map<string, OoWaiverPerson[]>; peertexts: Map<string, OoPeerText[]>; mcops: Map<string, OoMcOp[]>;
  drafts: Map<string, Set<string>>;
  /** 19.09: услуги брони без назначенного оператора. */
  mcneed: Map<string, OoMcNeed[]>;
  /** 26.09: прайс услуг брони (назначенных и нет). */
  mcprice: Map<string, OoMcPrice[]>;
  wphotos: Map<string, OoWaiverPhoto[]>;
}

interface RawExtras {
  materials?: { booking_id: number; id: number; kind: string; duration: string; poster: string | null; stream: string | null }[];
  unifans?: { booking_id: number; telegram_id: number; name: string; username: string | null; verified: number; avatar: string; via?: string; by?: string | null }[];
  created?: { id: number; quest?: string; date?: string; time?: string; custom_time?: string | null; type?: string; status?: string; source?: string | null; channel?: string | null; telegram?: string | null; players?: number; sum?: number; tea?: number | boolean; prepaid_amount?: number }[];
  extrawork?: { operator?: string; time_from?: string; time_to?: string; description?: string }[];
  halladmins?: { operator?: string; operator_id?: string; branch_id?: string; time_from?: string | null; time_to?: string | null }[];
  dcactions?: { action?: string; label?: string; reason?: string; staff_name?: string | null; at_hm?: string; booking_id?: number | null; booking_date?: string | null; booking_time?: string | null; booking_status?: string | null;
    info?: { created_by?: string; created_hm?: string; dc_name?: string | null; editors?: string[] } | null }[];
  rplayers?: { booking_id: number; name?: string; birth_date?: string; phone?: string; captain?: number; tags?: string }[];
  waiverpersons?: { booking_id: number; fio?: string; birth_date?: string; phone?: string }[];
  waiverphotos?: { booking_id: number; id: number; name?: string; by?: string }[];
  peerreports?: { booking_id: number; author?: string; subject?: string | null; activity?: string; impression?: string }[];
  mcops?: { id: number; booking_id: number; mc_name?: string; op_name?: string; rate?: number }[];
  mcneed?: { booking_id: number; mc_id: string; mc_name?: string }[];
  mcprices?: { booking_id: number; mc_id: string; mc_name?: string; base_price?: number | null; threshold?: number | null; extra_per_player?: number | null }[];
  drafts?: { booking_id: number; operator_id: string }[];
}

export async function fetchDayExtras(d: string, opt: { signal?: AbortSignal }): Promise<ExtrasMaps> {
  const r = await api<RawExtras>(`/api/game-reports/day-extras?date=${d}`, opt).catch(() => ({} as RawExtras));
  const mats = new Map<string, OoMaterial[]>();
  for (const m of r.materials ?? []) {
    const arr = mats.get(String(m.booking_id)) ?? [];
    arr.push({ id: m.id, kind: m.kind, duration: m.duration, poster: m.poster, stream: m.stream });
    mats.set(String(m.booking_id), arr);
  }
  const fans = new Map<string, OoFan[]>();
  for (const f of r.unifans ?? []) {
    const arr = fans.get(String(f.booking_id)) ?? [];
    const via: OoFanVia = f.via === "owner" || f.via === "link" || f.via === "invited" ? f.via : "qr";
    arr.push({ telegramId: f.telegram_id, name: f.name, username: f.username, verified: !!f.verified, avatar: f.avatar, via, by: f.by ?? null });
    fans.set(String(f.booking_id), arr);
  }
  const created: OoCreated[] = (r.created ?? []).map((b) => ({
    id: b.id, quest: b.quest ?? "—", date: b.date ?? "", time: (b.custom_time || b.time || "").slice(0, 5),
    type: b.type ?? "booking", status: b.status ?? "active", source: b.source ?? null, channel: b.channel ?? null,
    telegram: b.telegram ?? null, players: Number(b.players) || 0, sum: Number(b.sum) || 0, tea: !!b.tea,
    prepaid: (Number(b.prepaid_amount) || 0) > 0,
  }));
  const extrawork: OoExtraWorkRow[] = (r.extrawork ?? []).map((e) => ({
    operator: e.operator ?? "?", timeFrom: (e.time_from ?? "").slice(0, 5), timeTo: (e.time_to ?? "").slice(0, 5), description: e.description ?? "",
  }));
  const halladmins: OoHallAdminRow[] = (r.halladmins ?? []).map((h) => ({
    operator: h.operator ?? "?", operatorId: h.operator_id ?? "", branch: h.branch_id ?? "", timeFrom: (h.time_from ?? "").slice(0, 5), timeTo: (h.time_to ?? "").slice(0, 5),
  }));
  const dcactions: OoDcAction[] = (r.dcactions ?? []).map((a) => ({
    action: a.action ?? "", label: a.label ?? "", reason: a.reason ?? "", staff: a.staff_name ?? "", at: a.at_hm ?? "",
    bookingId: a.booking_id ?? null, bookingDate: a.booking_date ?? null, bookingTime: a.booking_time ?? null, bookingStatus: a.booking_status ?? null,
    info: a.info ? { createdBy: a.info.created_by ?? "", createdAt: a.info.created_hm ?? "", dcName: a.info.dc_name ?? null, editors: a.info.editors ?? [] } : null,
  }));
  const rplayers = new Map<string, OoReportPlayer[]>();
  for (const p of r.rplayers ?? []) {
    let tags: string[] = [];
    try { const t = JSON.parse(p.tags || "[]"); if (Array.isArray(t)) tags = t.map(String); } catch { /* мусор в tags → без тегов */ }
    const arr = rplayers.get(String(p.booking_id)) ?? [];
    arr.push({ name: p.name ?? "?", birthDate: p.birth_date ?? "", phone: p.phone ?? "", captain: !!p.captain, tags });
    rplayers.set(String(p.booking_id), arr);
  }
  const wpersons = new Map<string, OoWaiverPerson[]>();
  for (const w of r.waiverpersons ?? []) {
    const arr = wpersons.get(String(w.booking_id)) ?? [];
    arr.push({ fio: w.fio ?? "?", birthDate: w.birth_date ?? "", phone: w.phone ?? "" });
    wpersons.set(String(w.booking_id), arr);
  }
  const wphotos = new Map<string, OoWaiverPhoto[]>();
  for (const w of r.waiverphotos ?? []) {
    const arr = wphotos.get(String(w.booking_id)) ?? [];
    arr.push({ id: w.id, name: w.name ?? "", by: w.by ?? "" });
    wphotos.set(String(w.booking_id), arr);
  }
  const peertexts = new Map<string, OoPeerText[]>();
  for (const p of r.peerreports ?? []) {
    const arr = peertexts.get(String(p.booking_id)) ?? [];
    arr.push({ author: p.author ?? "?", subject: p.subject ?? null, activity: p.activity ?? "", impression: p.impression ?? "" });
    peertexts.set(String(p.booking_id), arr);
  }
  const mcops = new Map<string, OoMcOp[]>();
  for (const m of r.mcops ?? []) {
    const arr = mcops.get(String(m.booking_id)) ?? [];
    arr.push({ id: m.id, mcName: m.mc_name ?? "МК", opName: m.op_name ?? "?", rate: Number(m.rate) || 0 });
    mcops.set(String(m.booking_id), arr);
  }
  const mcneed = new Map<string, OoMcNeed[]>();
  for (const m of r.mcneed ?? []) {
    const arr = mcneed.get(String(m.booking_id)) ?? [];
    arr.push({ mcId: m.mc_id, mcName: m.mc_name ?? m.mc_id });
    mcneed.set(String(m.booking_id), arr);
  }
  const mcprice = new Map<string, OoMcPrice[]>();
  for (const m of r.mcprices ?? []) {
    const arr = mcprice.get(String(m.booking_id)) ?? [];
    arr.push({
      mcId: m.mc_id, mcName: m.mc_name ?? m.mc_id,
      base_price: m.base_price ?? null, threshold: m.threshold ?? null, extra_per_player: m.extra_per_player ?? null,
    });
    mcprice.set(String(m.booking_id), arr);
  }
  const drafts = new Map<string, Set<string>>();
  for (const d of r.drafts ?? []) {
    const k = String(d.booking_id);
    const set = drafts.get(k) ?? new Set<string>();
    set.add(String(d.operator_id));
    drafts.set(k, set);
  }
  return { mats, fans, created, extrawork, halladmins, dcactions, rplayers, wpersons, peertexts, mcops, mcneed, mcprice, drafts, wphotos };
}
